import { type MonitoringEvent } from '../../../../types/apiModels'
import { apiClient } from '../../../ruutsApi/client'
import endpoints from '../../../ruutsApi/endpoints'
import { unwrapCollection } from '../../../ruutsApi/normalize'

export const getMonitoringEventsByFarm = async ({
  farmId,
  signal,
}: {
  farmId: string
  signal?: AbortSignal
}) => {
  const response = await apiClient.get(endpoints.events, { params: { farmId }, signal })
  const monitoringEvents = unwrapCollection<MonitoringEvent>(response)
  return monitoringEvents.sort((a, b) => a?.name.localeCompare(b?.name))
}
